module.exports = __webpack_public_path__ + "img/Group 11.a4432bc7.svg";